import "./sidebar.scss";
import { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import VolunteerActivismRoundedIcon from "@mui/icons-material/VolunteerActivismRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import ChildCareRoundedIcon from "@mui/icons-material/ChildCareRounded";
import CardMembershipRoundedIcon from "@mui/icons-material/CardMembershipRounded";
import { Link, useNavigate } from "react-router-dom";
import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";
import MailRoundedIcon from "@mui/icons-material/MailRounded";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";

const COLLAPSE_KEY = "shaagirdAdminSidebarCollapsed";

const NavLink = ({ to, icon: Icon, label, collapsed }) => (
  <li>
    <Tooltip title={collapsed ? label : ""} placement="right">
      <span className="sidebarNavItemWrap">
        <Link to={to} className="sidebarNavLink">
          <Icon className="icon" />
          <span className="navLabel">{label}</span>
        </Link>
      </span>
    </Tooltip>
  </li>
);

const Sidebar = ({ isSidebar }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia("(max-width: 767px)").matches,
  );
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem(COLLAPSE_KEY) === "1",
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const onChange = () => setIsMobile(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const desktopCollapsed = !isMobile && collapsed;

  const toggleCollapsed = () => {
    setCollapsed((c) => {
      const next = !c;
      localStorage.setItem(COLLAPSE_KEY, next ? "1" : "0");
      return next;
    });
  };

  const onLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <div
      className={`sidebar ${desktopCollapsed ? "sidebar--collapsed" : ""}`}
      style={{
        display: isMobile ? (isSidebar ? "flex" : "none") : "flex",
      }}
    >
      <div className="top">
        <Link to="/dashboard" className="sidebarLogoLink">
          <img
            className="sidebarBrandLogo"
            src="/shaagird-logo.svg"
            alt="Shaagird"
          />
        </Link>
        {!isMobile && (
          <Tooltip title={desktopCollapsed ? "Expand menu" : "Collapse menu"}>
            <IconButton
              size="small"
              onClick={toggleCollapsed}
              className="sidebar-collapse-toggle adminRoundToggle"
              aria-label={
                desktopCollapsed ? "Expand sidebar" : "Collapse sidebar"
              }
            >
              {desktopCollapsed ? (
                <ChevronRightRoundedIcon />
              ) : (
                <ChevronLeftRoundedIcon />
              )}
            </IconButton>
          </Tooltip>
        )}
      </div>
      <hr />
      <div className="center">
        <ul>
          <p className="title">Main</p>

          <NavLink
            to="/dashboard"
            icon={DashboardRoundedIcon}
            label="Dashboard"
            collapsed={desktopCollapsed}
          />
          <p className="title">Lists</p>
          <NavLink
            to="/users"
            icon={PeopleAltRoundedIcon}
            label="Users"
            collapsed={desktopCollapsed}
          />
          <NavLink
            to="/category"
            icon={CategoryRoundedIcon}
            label="Categories"
            collapsed={desktopCollapsed}
          />
          <NavLink
            to="/kids"
            icon={ChildCareRoundedIcon}
            label="Kids"
            collapsed={desktopCollapsed}
          />

          <p className="title">Useful</p>
          <NavLink
            to="/sponsered"
            icon={VolunteerActivismRoundedIcon}
            label="Sponsored"
            collapsed={desktopCollapsed}
          />
          <NavLink
            to="/email-sms"
            icon={MailRoundedIcon}
            label="Send Email/SMS"
            collapsed={desktopCollapsed}
          />
          <NavLink
            to="/notification"
            icon={NotificationsActiveRoundedIcon}
            label="Notifications"
            collapsed={desktopCollapsed}
          />
          <NavLink
            to="/payments"
            icon={PaymentsRoundedIcon}
            label="Payments"
            collapsed={desktopCollapsed}
          />
          <NavLink
            to="/subscriptions"
            icon={AutorenewRoundedIcon}
            label="Subscriptions"
            collapsed={desktopCollapsed}
          />
          <NavLink
            to="/certificate"
            icon={CardMembershipRoundedIcon}
            label="Create Certificate"
            collapsed={desktopCollapsed}
          />
          <NavLink
            to="/create-report-pdf"
            icon={PictureAsPdfRoundedIcon}
            label="Create Report PDF"
            collapsed={desktopCollapsed}
          />
          <p className="title">User</p>
          <li>
            <Tooltip
              title={desktopCollapsed ? "Profile" : ""}
              placement="right"
            >
              <span className="sidebarNavItemWrap">
                <span className="sidebarNavLink sidebarNavLink--static">
                  <AccountCircleRoundedIcon className="icon" />
                  <span className="navLabel">Profile</span>
                </span>
              </span>
            </Tooltip>
          </li>
          <li>
            <Tooltip title={desktopCollapsed ? "Logout" : ""} placement="right">
              <span className="sidebarNavItemWrap">
                <button
                  type="button"
                  className="sidebarNavLink sidebarNavLink--button"
                  onClick={onLogout}
                >
                  <LogoutRoundedIcon className="icon" />
                  <span className="navLabel">Logout</span>
                </button>
              </span>
            </Tooltip>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
